class DateInputController {

    $onInit() {
        this.dateOptions = {
            maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            minDate: this.minDate,
            showWeeks: false
        };
        this.isDateViewOpen = false;
        // should default to true if not provided
        this.isRequired = this.isRequired === undefined ? true : this.isRequired;
    }

    /***
     * Open the calendar popup.
     */
    openDateView() {
        this.isDateViewOpen = true;
    }

    /***
     * Callback function to pass back up the selected date.
     */
    updateSelectedDate() {
        this.onDateSelect({date: this.selectedDate})
    }

}

export default DateInputController;


// WEBPACK FOOTER //
// ./app/common/date-input/date-input-controller.js